export const GRAPH_TYPES = {
  BAR: 'bar',
  LINE: 'line',
  SPLINE: 'spline',
  AREA_SPLINE: 'areaspline',
  STACKED: 'stacked'
};

export const METRIC_TYPE = {
  default: 'default',
  pm: 'customPmMetrics',
  goals: 'teamsGoals',
  custom: 'custom',
  reported: 'reportedMetrics'
};

export const GRAPH_UNIT_TYPES = {
  COUNT: 'count',
  PERCENTAGE: 'percentage'
};
